export type GuestCatalogViewMode = "grid" | "list";

export function parseGuestCatalogViewMode(value: string | null): GuestCatalogViewMode {
  return value === "list" ? "list" : "grid";
}
